// extracted by mini-css-extract-plugin
export default {"container":"FourZeroFour_container__uMn2b","header":"FourZeroFour_header__cZEyX","content":"FourZeroFour_content__iHdYE","footer":"FourZeroFour_footer__+0glx"};